module.exports = __webpack_public_path__ + "static/PartnerStampRed-ded7ea79b1ca254614c7ce5726e514ef.webp";